"use strict";

function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactIntl = require("react-intl");
var _Menu = _interopRequireDefault(require("@quintoandar/cozy-icons/Menu"));
var Styles = _interopRequireWildcard(require("./PageHeader.styles"));
var _IconButton = _interopRequireDefault(require("../../IconButton"));
var _messages = _interopRequireDefault(require("./messages"));
var _Dropdown = _interopRequireDefault(require("../../Dropdown"));
var _Typography = _interopRequireDefault(require("../../Typography"));
var _logService = require("../../tools/service/log/logService");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) {
    if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
      var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
      i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
  }
  return n["default"] = e, t && t.set(e, n), n;
}
var PageHeader = function PageHeader(_ref) {
  var logo = _ref.logo,
    searchBar = _ref.searchBar,
    tabs = _ref.tabs,
    secondaryItem = _ref.secondaryItem,
    primaryItem = _ref.primaryItem,
    menu = _ref.menu,
    fixed = _ref.fixed,
    onMenuClick = _ref.onMenuClick,
    children = _ref.children;
  var intl = (0, _reactIntl.useIntl)();
  var runPropsValidations = function runPropsValidations() {
    if (menu && onMenuClick) {
      (0, _logService.logSpecificErrorMessage)("PAGEHEADER", "Invalid props. You can't use menu with onMenuClick. onMenuClick is used when you want to create a menu button to trigger a navigationDrawer or another kind of event.");
    }
    if (onMenuClick && primaryItem) {
      (0, _logService.logSpecificErrorMessage)("PAGEHEADER", "Invalid props. You can't render the menu button with a primary item. For better structure of the interface, the menu button is intended to be used alone at the right content of the PageHeader.");
    }
  };
  (0, _react.useEffect)(function () {
    runPropsValidations();
  }, []);
  var renderMenu = function renderMenu() {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, !onMenuClick && menu && /*#__PURE__*/_react["default"].createElement(Styles.MenuDropdownContainer, {
      className: "cozy__menu"
    }, /*#__PURE__*/_react["default"].createElement(_Dropdown["default"], {
      placement: "bottom-end",
      triggerComponent: /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
        icon: _Menu["default"]
      })
    }, menu)), !primaryItem && onMenuClick && /*#__PURE__*/_react["default"].createElement("div", {
      className: "cozy__menu"
    }, /*#__PURE__*/_react["default"].createElement(Styles.MenuNavItem, {
      highlight: true,
      icon: _Menu["default"],
      onClick: onMenuClick,
      role: "menuitem"
    }, /*#__PURE__*/_react["default"].createElement(_Menu["default"], null), /*#__PURE__*/_react["default"].createElement(_Typography["default"], null, "Menu"))));
  };
  return /*#__PURE__*/_react["default"].createElement(Styles.PageHeaderWrapper, {
    fixed: fixed,
    role: "navigation",
    "aria-label": intl.formatMessage(_messages["default"].ariaLabelNavigation)
  }, /*#__PURE__*/_react["default"].createElement(Styles.Nav, {
    fixed: fixed,
    "aria-label": "PageHeaderMain"
  }, children, /*#__PURE__*/_react["default"].createElement(Styles.LeftContent, null, logo && /*#__PURE__*/_react["default"].createElement("div", null, logo), searchBar && /*#__PURE__*/_react["default"].createElement(Styles.SearchBarWrapper, null, searchBar), tabs && /*#__PURE__*/_react["default"].createElement("div", {
    className: "cozy__appBar__tabsContainer"
  }, tabs)), /*#__PURE__*/_react["default"].createElement(Styles.RightContent, null, secondaryItem && /*#__PURE__*/_react["default"].createElement("div", {
    className: "cozy__appBar__secondaryItemContainer"
  }, secondaryItem), renderMenu(), primaryItem && /*#__PURE__*/_react["default"].createElement("div", {
    className: "cozy__appBar__primaryItemContainer"
  }, primaryItem))));
};
PageHeader.propTypes = process.env.NODE_ENV !== "production" ? {
  logo: _propTypes["default"].node,
  searchBar: _propTypes["default"].node,
  tabs: _propTypes["default"].node,
  secondaryItem: _propTypes["default"].node,
  primaryItem: _propTypes["default"].node,
  menu: _propTypes["default"].node,
  onMenuClick: _propTypes["default"].func,
  fixed: _propTypes["default"].bool,
  children: _propTypes["default"].node
} : {};
var _default = exports["default"] = PageHeader;